import React from 'react';
import { CopyToClipboardButton } from 'src/components/CopyToClipboardButton';
import { truncateString } from 'src/utils/generalUtils';

export const OperatorInfo = ({
  operatorName,
  operatorId,
  region,
}: {
  operatorName?: string;
  operatorId?: string;
  region?: string;
}) => {
  return (
    <ul className="job-visualization-node__info">
      {operatorId && (
        <li>
          {operatorId}
          <CopyToClipboardButton
            data={operatorId}
            icon="content_copy"
            variant="link"
          />
        </li>
      )}
      {operatorName && (
        <li>
          {truncateString(operatorName, 35)}
          <CopyToClipboardButton
            data={operatorName}
            icon="content_copy"
            variant="link"
          />
        </li>
      )}
      {region && (
        <li>
          {region}
          <CopyToClipboardButton
            data={region}
            icon="content_copy"
            variant="link"
          />
        </li>
      )}
    </ul>
  );
};
